<script setup lang="ts">
import { ref, onMounted } from 'vue';
import MultistepForm from './components/MultistepForm.vue';
import { stepsPath } from './steps_path.json';
import type { QuestionItem, Settings, Program } from './types/general';
import { getPrograms, getSettings, getRecomends } from './api/index';

const programsData = ref<{
  count: number;
  programs: Program[];
}>();
const settings = ref<Settings>();

onMounted(async () => {
  programsData.value = await getPrograms();
  settings.value = await getSettings();
});
</script>

<template>
  <div class="program-finder">
    <MultistepForm
      v-if="settings && programsData"
      :steps-path="stepsPath as QuestionItem[]"
      :settings="settings"
      :programs="programsData.programs"
    />
  </div>
</template>
